<template>
    <div class="newPage">
        <div class="content">
            <div class='VOCNavBar'>
                <div class="BarList">

                    <template v-for="(item,index) in queryList">

                        <div class="navBarItem" :key="index" v-if="item==='startTime'">
                            <div class="navBarTitle">开始时间</div>

                            <div class="navBarValue">
                                <el-date-picker
                                        class="itemInput"
                                        v-model="queryParams[item]"
                                        size="mini"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择开始时间">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='endTime'">
                            <div class="navBarTitle">结束时间</div>

                            <div class="navBarValue">
                                <el-date-picker
                                        class="itemInput"
                                        v-model="queryParams[item]"
                                        size="mini"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择结束时间">
                                </el-date-picker>
                            </div>
                        </div>

                        <template v-if="item==='selectTime'">
                            <el-tooltip class="item" effect="dark" content="图片/数据展示天数为31天" placement="top" :key="index">
                                <div class="navBarItem" :key="index" v-if="item==='selectTime'">
                                    <div class="navBarTitle">时间</div>

                                    <div class="navBarValue">
                                        <el-date-picker
                                                class="itemInput"
                                                v-model="queryParams[item]"
                                                size="mini"
                                                type="datetime"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                placeholder="选择时间">
                                        </el-date-picker>
                                    </div>
                                </div>
                            </el-tooltip>
                        </template>

                        <div class="navBarItem" :key="index" v-if="item==='year'">
                            <div class="navBarTitle">年</div>
                            <div class="navBarValue">
                                <el-date-picker
                                        class="itemInput"
                                        v-model="queryParams[item]"
                                        type="year"
                                        placeholder="选择年" size="mini" value-format="yyyy">
                                </el-date-picker>
                            </div>
                        </div>


                        <div class="navBarItem" :key="index" v-if="item==='region'">
                            <div class="navBarTitle">区域城市</div>
                            <div class="navBarValue">
                                <el-cascader
                                        class="itemInput"
                                        ref="selectDeptRef"
                                        v-model="queryParams[item]"
                                        size="mini"
                                        :options="areaTree"
                                        :props="{label: 'lable',value:'lable',multiple: true}"
                                        clearable
                                ></el-cascader>
                            </div>
                        </div>


                        <!--                        todo  城市与站点相关联  有站点必有城市 先选站点再选城市-->
                        <div class="navBarItem" :key="index" v-if="item==='city'">
                            <div class="navBarTitle">城市</div>
                            <div class="navBarValue">
                                <el-cascader
                                        class="itemInput"
                                        ref="selectDeptRef"
                                        v-model="queryParams[item]"
                                        size="mini"
                                        :options="cityList"
                                        @change="onSearchClick"
                                        :props="{emitPath:false, checkStrictly: true,label: 'lable',value:'lable'}"
                                        clearable
                                ></el-cascader>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='stations'" v-show="showStations">
                            <div class="navBarTitle">站点</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams.stations" placeholder="请选择" size="mini"
                                           class="itemInput" @change="$forceUpdate()">
                                    <el-option v-for="(stations,indexs) in stationsList" :key="stations+indexs" :label="stations" :value="stations"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='Mstations'" v-show="showStations">
                            <div class="navBarTitle">站点</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams.Mstations" multiple  placeholder="请选择" size="mini"
                                           class="itemInput" @change="$forceUpdate()">
                                    <el-option v-for="(stations,indexs) in stationsList" :key="stations+indexs" :label="stations" :value="stations"></el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="navBarItem" :key="index" v-if="item==='allcity'">
                            <div class="navBarTitle">城市</div>
                            <div class="navBarValue">
                                <el-cascader
                                        class="itemInput"
                                        v-model="queryParams[item]"
                                        size="mini"
                                        collapse-tags
                                        :options="AllcityList"
                                        :props="{emitPath:false,multiple: true,label: 'lable',value:'lable'}"
                                        clearable
                                ></el-cascader>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='province'">
                            <div class="navBarTitle">省份</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择" size="mini"   class="itemInput">
                                    <el-option v-for="(cityItem,cityIndex) in cityList" :label="cityItem.lable" :key="cityIndex" :value="cityItem.lable"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='type'">
                            <div class="navBarTitle">文件类型</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择" size="mini"     class="itemInput">
                                    <el-option label="docx" value="docx"></el-option>
                                    <el-option label="pdf" value="pdf"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='pollutant'">
                            <div class="navBarTitle">污染物类型</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择"
                                           multiple size="mini" @change="forceUpdate" class="itemInput">
                                    <el-option label="PM2.5" value="PM2.5"></el-option>
                                    <el-option label="PM10" value="PM10"></el-option>
                                    <el-option label="SO2" value="SO2"></el-option>
                                    <el-option label="NO2" value="NO2"></el-option>
                                    <el-option label="CO" value="CO"></el-option>
                                    <el-option label="O3" value="O3"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='selectType'">
                            <div class="navBarTitle">返回类型</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择"     class="itemInput" size="mini">
                                    <el-option label="png" value="png"></el-option>
                                    <el-option label="excel" value="excel"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='dataSource'">
                            <div class="navBarTitle">数据来源</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择" size="mini" @change="data_sourceChange"  class="itemInput">
                                    <el-option label="导入数据" value="导入数据"></el-option>
                                    <el-option label="国控数据" value="国控数据"></el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="navBarItem" :key="index" v-if="item==='freq'">
                            <div class="navBarTitle">频率</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择" size="mini"    class="itemInput">
                                    <el-option label="周" value="周"></el-option>
                                    <el-option label="月" value="月"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='potType'">
                            <div class="navBarTitle">火点类型</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择" size="mini"     class="itemInput">
                                    <el-option label="常规火点图" value="常规火点图"></el-option>
                                    <el-option label="固定火点图" value="固定火点图"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='satellite'">
                            <div class="navBarTitle">卫星</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择" multiple size="mini"
                                           @change="forceUpdate"     class="itemInput">
                                    <el-option label="MODIS" value="MODIS"></el-option>
                                    <el-option label="JIVIRS" value="JIVIRS"></el-option>
                                    <el-option label="SUOMIVIRS" value="SUOMIVIRS"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='data_type'">
                            <div class="navBarTitle">数据类型</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择"  size="mini"
                                           class="itemInput">
                                    <el-option label="站点小时数据" value="站点小时数据"></el-option>
                                    <el-option label="城市小时数据" value="城市小时数据"></el-option>
                                    <el-option label="城市日数据" value="城市日数据"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <template v-if="item==='seasons'">
                            <div class="navBarItem" :key="index">
                                <div class="navBarTitle">选择类型</div>
                                <div class="navBarValue">
                                    <el-select v-model="seasonsType" placeholder="请选择"
                                               size="mini"
                                               @change="seasonsChange"
                                               class="itemInput">
                                        <el-option label="季节" value="季节"></el-option>
                                        <el-option label="月份" value="月份"></el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="navBarItem" :key="index+'seasons'" v-show="seasonsType==='季节'">
                                <div class="navBarTitle">季节</div>
                                <div class="navBarValue">
                                    <el-select v-model="queryParams.seasons"  multiple placeholder="请选择" size="mini"
                                               class="itemInput">
                                        <el-option label="春季" value="春季"></el-option>
                                        <el-option label="夏季" value="夏季"></el-option>
                                        <el-option label="秋季" value="秋季"></el-option>
                                        <el-option label="冬季" value="冬季"></el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="navBarItem" :key="index+'month'" v-show="seasonsType==='月份'">
                                <div class="navBarTitle">月份</div>
                                <div class="navBarValue">
                                    <el-select v-model="queryParams.month" multiple placeholder="请选择" size="mini"
                                               class="itemInput">
                                        <el-option label="一月" value="一月"></el-option>
                                        <el-option label="二月" value="二月"></el-option>
                                        <el-option label="三月" value="三月"></el-option>
                                        <el-option label="四月" value="四月"></el-option>
                                        <el-option label="五月" value="五月"></el-option>
                                        <el-option label="六月" value="六月"></el-option>
                                        <el-option label="七月" value="七月"></el-option>
                                        <el-option label="八月" value="八月"></el-option>
                                        <el-option label="九月" value="九月"></el-option>
                                        <el-option label="十月" value="十月"></el-option>
                                        <el-option label="十一月" value="十一月"></el-option>
                                        <el-option label="十二月" value="十二月"></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </template>

                        <div class="navBarItem" :key="index" v-if="item==='durations'">
                            <div class="navBarTitle">对比范围</div>
                            <div class="navBarValue">
                                <el-input v-model="queryParams[item]" size="mini" placeholder="请输入"     class="itemInput"></el-input>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='freq_days'">
                            <div class="navBarTitle">持续天数</div>
                            <div class="navBarValue">
                                <!--                                <div class="navBarValue">-->
                                <el-input v-model="queryParams[item]" size="mini" placeholder="请输入"   class="itemInput"></el-input>
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="navBarItem" :key="index" v-if="item==='fileUpload'">
                            <div class="navBarTitle">文件上传</div>
                            <div class="navBarValue">
                                <el-upload
                                        action="#"
                                        :before-upload="beforeUpload"
                                        accept=".xls, .xlsx"
                                        :on-change="(res,fileList)=>FileOnChange(res,fileList,item)"
                                        :limit='1'
                                        :auto-upload="false"
                                >
                                    <a-button size="small" type="primary" class="btn" >点击上传</a-button>
                                </el-upload>
                            </div>
                        </div>


                    </template>

                </div>

                <div class="tips" v-if="content">
                    {{content}}
                </div>
                <div class="btnBox">
                    <el-button type="primary" size="mini" @click="getList">获取</el-button>
                    <el-button type="primary" size="mini" @click="jumpIde"  v-if="isAuth('sso:auth:jump')">IDE</el-button>
<!--                    <el-button type="primary" disabled  size="mini" @click="handleOpenDetail">定时任务</el-button>-->
                </div>
            </div>
            <div class="showContent">
                <breadcrumb></breadcrumb>
                <div class="VOCContent" v-if="resultObj.resultType==='value'" v-loading="loading">
                    <pre>{{resultObj.value}}</pre>
                </div>
                <div class="VOCContent" v-if="resultObj.resultType==='png'" v-loading="loading" >
                    <template v-if="resultObj.value">
                        <div class="imgItem">
                            <img :src="resultObj.value" alt="">
                        </div>
                    </template>
                    <template v-else>
                        <div class="down">
                            <div class="downBtn" @click="downAllImg">下载</div>
                        </div>
                        <div class="imgItem" v-for="(item,index) in resultObj.list" :key="index">
                            <img :src="item.value" alt="">
                        </div>
                    </template>
                </div>

                <div class="VOCContent VOCContentPdf" v-if="resultObj.resultType==='pdf'" v-loading="loading" >
                    <!--<div class="VOCContent" >-->
                    <pdf v-for="i in pdfPage" :key="i" :src="pdfSrc" :page="i"
                         ref="myPdf"></pdf>
                </div>

                <div class="VOCContent VOCContentPdf" v-if="resultObj.resultType==='excel'" v-loading="loading">
                    <div class="excelItem" v-for="(item,index) in resultObj.list" :key="index">
                        <div class="excelName">{{item.name}}</div>
                        <div class="excelDown" @click="excelDown(item.value,item.name)">下载</div>
                    </div>
                </div>

                <div class="VOCContent VOCContentPdf" v-if="resultObj.resultType==='word'" v-loading="loading">
                    <div class="excelItem" v-for="(item,index) in resultObj.list" :key="index">
                        <div class="excelName">{{item.name}}</div>
                        <div class="excelDown" @click="wordDown(item.value,item.name)">下载</div>
                    </div>
                </div>
                <div class="VOCContent " v-if="resultObj.resultType==='echart'" v-loading="loading">
                    <bar-chart :echartdata="resultObj.list" ></bar-chart>
                </div>

            </div>
        </div>


        <el-dialog
                title="定时任务详情"
                :visible.sync="dialogVisible"
                width="50%"
        >
            <el-form :model="timingForm" ref="timingForm" label-width="100px" class="demo-dynamic">
                <el-form-item
                        prop="baseTime"
                        label="基准值"
                        :rules="[
                              { required: true, message: '请输入基准值', trigger: 'blur' },
                            ]"
                >
                    <el-input v-model="timingForm.baseTime" size="mini"></el-input>
                </el-form-item>
                <el-form-item
                        prop="cron"
                        label="cron表达式"
                        :rules="[
                              { required: true, message: '请输入cron表达式', trigger: 'blur' },
                            ]"
                >
                    <el-input v-model="timingForm.cron" size="mini"></el-input>
                </el-form-item>
                <el-form-item
                        prop="status"
                        label="状态"
                >
                    <el-radio-group v-model="timingForm.status">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="-1">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>

                <template v-for="(item, index) in queryList">
                    <el-form-item
                            v-if="item==='startTime' || item==='endTime'"
                            :label="item==='startTime' ? '开始时间' : '结束时间'"
                            :key="index"
                    >
                        <el-date-picker
                                v-model="queryParams[item]"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item
                            v-if="item==='year'"
                            label="年"
                            :key="index"
                    >
                        <el-date-picker
                                v-model="queryParams[item]"
                                type="year"
                                placeholder="选择年" size="mini" value-format="yyyy">
                        </el-date-picker>
                    </el-form-item>
                </template>
            </el-form>


            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">新 增</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>

    import Breadcrumb from "../../components/breadcrumb";
    import XLSX from 'xlsx'
    // import pdf from 'vue-pdf'
    import pdf from '../../components/vue-pdf'
    import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
    import {saveAs} from "file-saver";
    import url from "../../utils/UrlApi"
    import BarChart from "../../components/dashboard/BarChart";

    export default {
        name: "dataAChart",
        components: {BarChart, Breadcrumb, pdf},
        computed: {
            id: {
                get() {
                    return this.$route.query.id
                }
            },
            name: {
                get() {
                    return this.$route.query.name
                }
            }
        },
        data() {
            return {
                queryParams: {},
                queryList: [],
                loading: false,
                resultObj: '',
                dialogVisible: false,
                timingForm: {
                    id: '',
                    cron: '',
                    baseTime: '',
                    status: 1
                },
                cityList: [],
                AllcityList: [],

                areaTree:[],


                pdfSrc: '',
                pdfPage: 0,
                isClick: 0,

                sheetList:[],
                stationsList:[],

                seasonsType:'',

                showStations:false,

                content:'',
                ruleList:[],   // 数据校验规则


            }
        },
        created() {
            this.init()
            this.getCityList()
            this.getareaList()
            // this.getPara()
        },
        methods: {

            init() {
                this.queryParams = {}
                this.queryList = []
                this.resultObj = ''
                this.stationsList = []
                this.showStations = false
                this.getQuery()

                let pageParams = JSON.parse(localStorage.getItem('pageParams'))



                if(pageParams && pageParams[this.id]){
                    // console.log(this.id)
                    // console.log(pageParams[this.id])
                    this.queryParams =  pageParams[this.id]

                    if(
                       (this.queryParams['city'] && this.queryParams['Mstations'] !== undefined && this.queryParams['dataSource'])
                        ||
                        (this.queryParams['city'] && this.queryParams['stations'] !== undefined && this.queryParams['dataSource'])
                    ){
                        //
                        this.getPara()
                        this.showStations = true
                    }

                }


                // this.getList()
            },

            handleRule(){

                let time = 0
                let msg = ''

                this.ruleList.forEach(item=>{
                    if(item.param==='day'){
                        time = item.paramValue
                        msg = item.content
                    }
                })

                // console.log(time)

                if(this.queryParams.startTime && this.queryParams.endTime && time){
                    const time1 = this.$moment(this.queryParams.startTime);
                    const time2 = this.$moment(this.queryParams.endTime);

                    // 计算相差天数
                    const daysDiff = time2.diff(time1, 'days');
                    if(daysDiff>time){
                        this.$message.error(msg)
                        return false
                    }else {
                        return true
                    }
                }else {
                    return true
                }
            },


            getList() {

                if (this.isClick === 1) {
                    return
                }

                // 校验基础验证规则
                // console.log(this.handleRule())
                if(!this.handleRule()){
                    return;
                }




                /**
                 * TODO 补丁
                 *
                 * 阻止在外层增加loading 图片闪现
                 * 在内层 绑定 loading 第一次展示png 的loading 问题
                 *
                 * */
                this.resultObj={
                    resultType :'png'
                }


                this.isClick = 1
                let data = this.queryParams


                /**
                 * TODO  部分参数校验
                 *
                 *  durations：不能小于等于0
                 freq_days：不能超过durations、不能小于等于0
                 * */
                console.log(data)
                if(data.durations || data.freq_days){
                    if (!/^[1-9]+[0-9]*]*$/.test(data.durations)){
                        this.$message.error('对比范围不能小于等于0')
                        this.isClick = 0
                        return;
                    }

                    if (!/^[1-9]+[0-9]*]*$/.test(data.freq_days)){
                        this.$message.error('持续天数不能小于等于0')
                        this.isClick = 0
                        return;
                    }

                    if (data.freq_days > data.durations){
                        this.$message.error('持续天数不能大于对比范围')
                        this.isClick = 0
                        return;
                    }
                }










                data.menuId = this.id
                this.pdfPage = 0
                this.pdfSrc = ''

                this.loading = true
                this.$http.post(url.onlineModuleProxy, data).then(res => {
                    this.loading =false
                    this.isClick = 0
                    if (res.data.code === '200') {
                        //
                        let responseData = res.data.data

                        if (responseData.resultType === 'pdf') {
                            // this.pdfSrc = pdf.createLoadingTask({url: responseData.value, CMapReaderFactory});
                            // this.pdfSrc.promise.then(pdf => {
                            //     this.pdfPage = pdf.numPages;
                            // });
                            this.downloadFile(this.name + '.pdf', responseData.value);
                        }

                        if (responseData.resultType === 'docx') {
                            this.downloadFile(this.name + '.docx', responseData.value);
                        }


                        this.resultObj = res.data.data

                        // this.isClick = 0
                    } else {

                        this.$message({
                            customClass:"message-error",
                            dangerouslyUseHTMLString: true,
                            message: res.data.message,
                            duration:8000,
                            type:'error',
                            showClose:true,
                        });

                        // this.$message.error(res.data.message)
                    }
                })
            },

            downloadFile(fileName, content) {
                let aLink = document.createElement('a');
                let blob = this.base64ToBlob(content); //new Blob([content]);

                let evt = document.createEvent("HTMLEvents");
                console.log("点击下载", evt)
                evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
                aLink.download = fileName;
                aLink.href = URL.createObjectURL(blob);

                // aLink.dispatchEvent(evt);
                aLink.click()
            },
            //base64转blob
            base64ToBlob(code) {
                let parts = code.split(';base64,');
                let contentType = parts[0].split(':')[1];
                let raw = window.atob(parts[1]);
                let rawLength = raw.length;

                let uInt8Array = new Uint8Array(rawLength);

                for (let i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                return new Blob([uInt8Array], {type: contentType});
            },

            getCityList() {
                let data = {}
                this.$http.get(url.addressMenuAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.cityList = res.data.data

                        this.AllcityList = [
                            {
                                lable:'全国',
                                levle:0,
                                children:res.data.data
                            }
                        ]
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            getareaList() {
                let data = {}
                this.$http.get(url.addressAreaAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.areaTree = res.data.data

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getQuery() {
                let data = {
                    menuId: this.id
                }
                this.$http.get(url.onlineModulemenuInfoForContent, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        //

                        // setTimeout(()=>{
                        this.ruleList =  res.data.data.validationRules ? JSON.parse(res.data.data.validationRules) :[]
                        this.queryList = res.data.data.list
                        this.content = res.data.data.content
                        // },200)

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            handleOpenDetail() {
                this.dialogVisible = true
                // this.getInfo()
            },
            submitForm() {
                this.$refs['timingForm'].validate((valid) => {
                    if (valid) {


                        let data = this.queryParams

                        let timingForm = this.timingForm
                        for (var key in timingForm) {
                            if (timingForm.hasOwnProperty(key) === true) {
                                data[key] = timingForm[key];
                            }
                        }

                        data.menuId = this.id


                        // if (data.id) {
                        //     this.$http.post(url.wordTaskupdate, data).then(res => {
                        //         if (res.data.code === '200') {
                        //             this.$message.success('修改定时任务成功')
                        //             this.dialogVisible = false
                        //         } else {
                        //             this.$message.error(res.data.message)
                        //         }
                        //     })
                        // } else {
                        this.$http.post(url.wordTaskSaveApi, data).then(res => {
                            if (res.data.code === '200') {
                                this.$message.success('增加定时任务成功')
                                this.dialogVisible = false
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                        // }

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

            downAllImg(){
                this.resultObj.list.forEach(item=>{
                    this.imgDown(item.value,item.name)
                })
            },

            //  excel 下载
            excelDown(result,fileName){
                var raw = window.atob(result.split(',')[1]);
                var uInt8Array = new Uint8Array(raw.length);
                for (var i = 0; i < raw.length; i++) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }

                const link = document.createElement("a");
                const blob = new Blob([uInt8Array],{
                    // type: 'application/vnd.ms-excel'
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                })

                link.style.display = 'none';
                link.href = URL.createObjectURL(blob);
                link.setAttribute('download',fileName);

                document.body.appendChild(link)
                link.click()

                document.body.removeChild(link)
            },

            // 图片下载
            imgDown(result,fileName){
                var raw = window.atob(result.split(',')[1]);
                var uInt8Array = new Uint8Array(raw.length);
                for (var i = 0; i < raw.length; i++) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }

                const link = document.createElement("a");
                const blob = new Blob([uInt8Array],{
                    // type: 'application/vnd.ms-excel'
                    type: 'image/png'
                })

                link.style.display = 'none';
                link.href = URL.createObjectURL(blob);
                link.setAttribute('download',fileName);

                document.body.appendChild(link)
                link.click()

                document.body.removeChild(link)
            },

            // word下载

            wordDown(result,fileName){


                var arr = result.split(',');

                var mime = arr[0].match(/:(.*?);/)[1],

                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);

                while (n--) {

                    u8arr[n] = bstr.charCodeAt(n);

                }

                var blob = new Blob([u8arr], { type: mime })
                saveAs(blob, fileName);
            },

            forceUpdate(val){
                // console.log(val)
            },


            beforeUpload(file){
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            FileOnChange(files,fileList,item){
                let self = this
                var file =  files.raw;
                let sheetList= []  //
                let base64file = ''


                var reader = new FileReader();
                reader.readAsDataURL(file);
                //转base64
                reader.onload = function(e) {
                    let data  = e.target.result
                    base64file = data


                    let reader2 = new FileReader()
                    reader2.readAsBinaryString(file)
                    reader2.onload = ev => {
                        let dataBinary =  ev.target.result
                        let workBook = XLSX.read(dataBinary, {type: 'binary', cellDates: true})
                        for (var sheet in workBook.Sheets) {
                            if (workBook.Sheets.hasOwnProperty(sheet)) {
                                sheetList.push(sheet)
                            }
                        }
                        self.queryParams[item] = base64file+'&'+sheetList[0]
                        console.log(self.queryParams[item])

                    }



                }




                //
                // this.$nextTick(e=>{
                //     this.queryParams[item] = base64file+'&'+sheetList[0]
                //     console.log(this.queryParams[item])
                // })
            },

            getPara(){
                let data = {
                    menuId: this.id,
                    city:this.queryParams['city'],
                    dataSource: this.queryParams['dataSource'],
                }

                this.stationsList = []

                this.$http.get(url.mapperCityStation, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.stationsList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            seasonsChange(value){
                // console.log(value)
                console.log(this.queryParams)
                if (value==='季节'){
                    this.queryParams.month = []
                }else if (value==='月份') {
                    this.queryParams.seasons = []
                }
            },

            onSearchClick () {
                // console.log('change')
                // console.log( this.$refs.selectDeptRef)
                this.$refs.selectDeptRef[0].dropDownVisible = false

                // 切换城市时  判断是否存在 站点 && 数据来源 dataSource
                if (this.queryList.includes('stations') && this.queryParams['dataSource'] ){
                    this.queryParams.stations = ''
                    this.getPara()
                    this.showStations = true
                }else if( this.queryList.includes('Mstations') && this.queryParams['dataSource']){
                    this.queryParams.Mstations = []
                    this.getPara()
                    this.showStations = true
                } else {
                    this.showStations = false
                }
            },

            data_sourceChange(){
                // 切换数据来源时  判断是否存在 站点 && 城市 dataSource
                if (this.queryList.includes('stations') &&  this.queryParams['city']){
                    this.queryParams.stations = ''
                    this.getPara()
                    this.showStations = true
                }else if( this.queryList.includes('Mstations') &&  this.queryParams['city']){
                    this.queryParams.Mstations = []
                    this.getPara()
                    this.showStations = true
                } else {
                    this.showStations = false
                }
            },

            saveParams(){
                // console.log('---保存-')
                let pageParams = JSON.parse(localStorage.getItem('pageParams'))

                if(!pageParams){
                    pageParams = {}
                }

                pageParams[this.id] = this.queryParams
                let obj = JSON.stringify(pageParams)
                localStorage.setItem('pageParams',obj)
                // console.log(obj)
            },

            /**
             *
             *  // 跳转IDE项目。
             *  先获取展示系统token
             *  然后通过展示系统token 获取后台管理token,
             *  再组装参数跳转IDE项目
             *
             *
             */
            jumpIde(){
                let self = this
                let data = {}

                const loading = this.$loading({
                    lock: true,
                    text: '处理中...',
                    spinner: 'el-icon-loading',
                });



                this.$http.get(url.ssoauthjump, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        // console.log(res)

                        let data2 = {
                            token:res.data.data
                        }
                        this.$http.get('https://www.craes-air.cn/dst-admin/sso/auth/login', {
                        // this.$http.get('http://47.92.238.196:9099/dst-dev/sso/auth/login', {
                            params: data2
                        }).then(res2 => {
                            console.log(res)
                            if (res2.data.code === 200) {
                                loading.close()
                                let url = 'https://pro.cleanair.work/idea/#/?token=Bearer'+res2.data.token
                                +'&menuId=0-'+self.id

                                window.open(url,'_blank')

                            } else {
                                loading.close()
                                this.$message.error(res2.data.msg)
                            }
                        })
                    } else {
                        loading.close()
                        this.$message.error(res.data.message)
                    }
                })
            },





        },



        beforeRouteUpdate(to, from, next) {
            //     路由切换
            //     初始化页面
            this.saveParams()

            console.log(this.id)
            next()


            this.init()

        },

        beforeRouteLeave(to, from, next){
            this.saveParams()
            console.log(this.id)

            next()
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/vocContent";

    .VOCNavBar {
        overflow: hidden;
        .BarList {
            flex: 1;
            overflow: auto;
        }
        .tips{
            border-top: 1px solid #ddd;
            border-bottom: 1px solid #ddd;
            padding: 4px;
            font-size: 12px;
        }
    }

    .VOCContent {
        .imgItem{
            padding: 20px 0;
            text-align: center;
            img {
                max-width: 90%;
            }
        }

        .excelItem{
            display: flex;
            align-items: center;
            .excelName{
                margin: 10px;
            }
            .excelDown{
                background-color: #2ca9dc;
                padding: 4px 10px;
                text-align: center;
                color: #fff;
                border-radius: 2px;
                cursor: pointer;
            }
        }
        .down{
            display: flex;
            justify-content: right;
            .downBtn{
                background-color: #2ca9dc;
                padding: 4px 10px;
                text-align: center;
                color: #fff;
                border-radius: 2px;
                cursor: pointer;
            }
        }
    }

    .VOCContentPdf {
        padding: 0 20px;
    }
</style>




<!--
<template>
    &lt;!&ndash; 直接循环已选结果就可以 &ndash;&gt;
    <div>
        <div v-for="(item,index) in items" :key="index">
            <el-select
                    multiple
                    placeholder="请选择"
                    v-model="selectHierarchyCol[item]"
                    @change="handleSelectChange"
            >
                <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                </el-option>
            </el-select>
            <el-button v-if="index == 0" type="primary" icon="el-icon-plus" style="margin-left:2px" @click="oqsHierarchy(0)" ></el-button>
            <el-button icon="el-icon-minus" style="margin-left:2px" @click="oqsHierarchy(index)" ></el-button>
        </div>
    </div>
</template>
<script>
    const hierarchyColList = [{id:'111',label:'哈哈哈'},{id:'222',label:'是是是'},{id:'333',label:'我我我'}]
    const selectedData = []
    export default {
        data() {
            return {
                options: hierarchyColList,
                selectHierarchyCol: {}, // 这样的话默认会有一个select

                items:['test1','test2','test3','test4',]
            };
        },
        mounted(){
            // 延迟赋值
            setTimeout(()=>{
                    this.items.forEach(res=>{
                        // if (res === 'test1') {
                        //     this.selectHierarchyCol[res] = []
                        // }
                        // if (res === 'test3') {
                        //     this.selectHierarchyCol[res] = []
                        // }
                    })
             },200)
        },
        methods: {
            init() {
                this.selectHierarchyCol = {}
            },
            // 添加删除
            oqsHierarchy(index){
                if(index){
                    this.selectHierarchyCol.splice(index,1)
                }else{
                    this.selectHierarchyCol.push([])
                }
            },
            // 输出已选的值
            handleSelectChange(selectedVal){
                // 这里会输出已选择的options数组，值是绑定的value
                console.log('当前选择器修改后的值：',selectedVal)
            }
        },
        beforeRouteUpdate(to, from, next) {
            //     路由切换
            //     初始化页面
            next()
            this.init()
        },
    };
</script>-->
